import { useDispatch, useSelector } from 'react-redux';

import { useState } from 'react';
import { TabLabel } from 'pages/Workshop/components/TabLabel';
import { ArchiveDropdown } from 'pages/Workshop/components/ArchiveDropdown';
import { WorkshopPageTabs } from 'pages/Workshop/components/WorkshopPageTabs';
import { WorkshopTabsTable } from 'pages/Workshop/components/WorkshopTabsTable';

import { FORM_TABS, formsEmptyText } from './helper';

import { getUserRolesMapSelector } from 'store/selectors/user';
import { useManageFormTabs } from './useManageFormTabs';
import { getActiveFormTabSelector } from 'store/selectors/requestFormProcess';
import { setFormsTabEffect } from 'store/effects/formProcess';

export const FormTabs = (props) => {
  const { isClient, isThirdParty } = useSelector(getUserRolesMapSelector);

  const [archivedValue, setArchivedValue] = useState('');

  const isClientOrThidParty = isClient || isThirdParty;

  const { activeFormTab } = useSelector(getActiveFormTabSelector);

  const [activeKey, setActiveKey] = useState<any>(
    activeFormTab || (isClientOrThidParty ? FORM_TABS.WaitingOnYou : FORM_TABS.Draft),
  );

  const dispatch = useDispatch();

  const { formsData, ...restProps } = props;
  const { tableProps } = useManageFormTabs({ ...restProps, activeKey });

  const getArchivedDataSource = () => {
    if (archivedValue === FORM_TABS.Voided) return formsData.voidedData;

    if (archivedValue === FORM_TABS.Cancelled) return formsData.cancelledData;

    if (archivedValue === FORM_TABS.Completed) return formsData.completedData;

    return [];
  };

  const getArchivedOptions = () => {
    const { voidedData, completedData } = formsData;

    return [
      { label: 'Voided', count: voidedData.length },
      { label: 'Completed', count: completedData.length },
    ];
  };

  const archivedDataSource = getArchivedDataSource();

  const tabItems = [
    ...(!isClientOrThidParty
      ? [
          {
            key: FORM_TABS.Draft,
            label: <TabLabel title={FORM_TABS.Draft} count={formsData.draftData.length} />,
            children: (
              <WorkshopTabsTable
                dataSource={formsData.draftData}
                emptyText={formsEmptyText}
                {...tableProps(formsData.draftData.length > 0 ? formsData.draftData[0].status : '')}
              />
            ),
          },
        ]
      : []),
    {
      key: FORM_TABS.WaitingOnYou,
      label: <TabLabel title={FORM_TABS.WaitingOnYou} count={formsData.waitingOnYouData.length} />,
      children: (
        <WorkshopTabsTable
          dataSource={formsData.waitingOnYouData}
          emptyText={formsEmptyText}
          {...tableProps(
            formsData.waitingOnYouData.length > 0 ? formsData.waitingOnYouData[0].status : '',
          )}
        />
      ),
    },
    {
      key: FORM_TABS.WaitingOnOthers,
      label: (
        <TabLabel title={FORM_TABS.WaitingOnOthers} count={formsData.waitingOnOthersData.length} />
      ),
      children: (
        <WorkshopTabsTable
          dataSource={formsData.waitingOnOthersData}
          emptyText={formsEmptyText}
          {...tableProps(
            formsData.waitingOnOthersData.length > 0 ? formsData.waitingOnOthersData[0].status : '',
          )}
        />
      ),
    },
    {
      key: FORM_TABS.RecentlyCompleted,
      label: (
        <TabLabel
          title={FORM_TABS.RecentlyCompleted}
          count={formsData.recentlyCompletedData.length}
        />
      ),
      children: (
        <WorkshopTabsTable
          dataSource={formsData.recentlyCompletedData}
          emptyText={formsEmptyText}
          {...tableProps(
            formsData.recentlyCompletedData.length > 0
              ? formsData.recentlyCompletedData[0].status
              : '',
          )}
        />
      ),
    },
    {
      key: FORM_TABS.Declined,
      label: <TabLabel title={FORM_TABS.Declined} count={formsData.declinedData.length} />,
      children: (
        <WorkshopTabsTable
          dataSource={formsData.declinedData}
          emptyText={formsEmptyText}
          {...tableProps(formsData.declinedData.length > 0 ? formsData.declinedData[0].status : '')}
        />
      ),
    },
    {
      key: FORM_TABS.Archive,
      label: (
        <ArchiveDropdown
          archivedValue={archivedValue}
          setArchivedValue={(value) => {
            setArchivedValue(value);
            setActiveKey(FORM_TABS.Archive);
          }}
          archivedData={archivedDataSource}
          dropdownOptions={getArchivedOptions()}
        />
      ),
      children: archivedValue ? (
        <WorkshopTabsTable
          archivedValue={archivedValue}
          dataSource={archivedDataSource}
          emptyText={formsEmptyText}
          {...tableProps(archivedDataSource.length > 0 ? archivedDataSource[0].status : '')}
        />
      ) : null,
    },
  ];

  const resetFormTab = () => {
    activeFormTab && dispatch(setFormsTabEffect(null));
  };

  return (
    <WorkshopPageTabs
      activeKey={activeKey}
      items={tabItems}
      onChange={(value) => {
        resetFormTab();
        if (archivedValue && value !== FORM_TABS.Archive) {
          setArchivedValue('');
        }

        value !== FORM_TABS.Archive && setActiveKey(value);
      }}
    />
  );
};
